import store from "./../../store";
import { THUMBNAIL_ANNOTATION_TYPE } from "../../config/config";

export default {
  computed: {
    isCirrusReference(){
      let exam = store.getters.examBySrNo(this.image.exSrNo);
      if (!exam) return false;
    
      let device = store.getters.devices.find(d => d.devSrNo == exam.devSrNo);
      let description = device.description.toLowerCase();
      return this.isCirrus && this.image.imgSubType=="reference" && (description.includes("oct") || description.includes("scans"));
    },
    isSpectralisSLO(){
      return (this.image.exDevice.toLowerCase().includes("spectralis") &&  this.image.imgType == "IMAGE-SLO");
    },
    showDropdown(){
      return this.isCirrusReference || this.isSpectralisSLO; 
    },
    thumbnailAnnotation(){
      if(this.image.exDevice.toLowerCase().includes("spectralis") && this.image.imgType == "IMAGE-SLO" && this.image.imgGroup.toLowerCase().includes("radialcircles")){
        return THUMBNAIL_ANNOTATION_TYPE.spectralisRadialCircle;
      }
      else if(this.image.exDevice.toLowerCase().includes("spectralis") &&  this.image.imgType == "IMAGE-SLO" && this.image.imgGroup.toLowerCase().includes("circle")){
        return THUMBNAIL_ANNOTATION_TYPE.spectralisCircle;
      }
      else if(this.image.exDevice.toLowerCase().includes("spectralis") &&  this.image.imgType == "IMAGE-SLO" && (this.image.imgGroup.toLowerCase().includes("volume") || this.image.imgGroup.toLowerCase().includes("cube"))){
        return THUMBNAIL_ANNOTATION_TYPE.spectralisVolume;
      }
      else if(this.image.exDevice.toLowerCase().includes("spectralis") && this.image.imgType == "IMAGE-SLO" && this.image.imgGroup.toLowerCase().includes("star")){
        return THUMBNAIL_ANNOTATION_TYPE.spectralisRadial;
      }
      else if(this.image.exDevice.toLowerCase().includes("spectralis") && this.image.imgType == "IMAGE-SCN" && this.image.imgGroup.toLowerCase().includes("star")){
        return THUMBNAIL_ANNOTATION_TYPE.spectralisRadialSCN;
      }
      else if(this.isCirrusReference && this.image.imgData.toLowerCase().includes("macular")){
        return THUMBNAIL_ANNOTATION_TYPE.cirrusReferenceMacular;
      }
      else if(this.isCirrusReference && this.image.imgData.toLowerCase().includes("raster")){
        return THUMBNAIL_ANNOTATION_TYPE.cirrusReferenceRaster;
      }
      else if(this.isCirrusReference && this.image.imgData.toLowerCase().includes("optic disc")){
        return THUMBNAIL_ANNOTATION_TYPE.cirrusReferenceOpticDisc;
      }
      else if(this.image.exDevice.toLowerCase().includes("spectralis") && this.image.imgType == "IMAGE-SLO" && this.image.imgGroup.toLowerCase().includes("section")){
        return THUMBNAIL_ANNOTATION_TYPE.spectralisSection;
      }
      return null;
    },
   
    /* isSpectralisCircle(){
      return (this.image.exDevice.toLowerCase().includes("spectralis") &&  this.image.imgType == "IMAGE-SLO" && this.image.imgGroup.toLowerCase().includes("circle"));
    },
    isSpectralisVolume(){
      return (this.image.exDevice.toLowerCase().includes("spectralis") &&  this.image.imgType == "IMAGE-SLO" && this.image.imgGroup.toLowerCase().includes("volume"));
    },
    isSpectralisRadial(){
      return (this.image.exDevice.toLowerCase().includes("spectralis") && this.image.imgType == "IMAGE-SLO" && this.image.imgGroup.toLowerCase().includes("star"));
    },*/
    /* isSpectralisRadialSCN(){
      return (this.image.exDevice.toLowerCase().includes("spectralis") && this.image.imgType == "IMAGE-SCN" && this.image.imgGroup.toLowerCase().includes("star"));
    },*/
   
    /* cirrusReferenceMacular(){
      return this.isCirrusReference && this.image.imgData.toLowerCase().includes("macular");
    },*/
    /* cirrusReferenceRaster(){
      return this.isCirrusReference && this.image.imgData.toLowerCase().includes("raster");
    },*/ 
    showMisc(){
      return this.showDropdown || this.cirrusReferenceMacular || this.cirrusReferenceRaster;
    }, 
  }
}